module.exports = __webpack_public_path__ + "static/asset_management-88e0da3bd743726703f0cc6cba170aa3.jpg";